import React from 'react';
import PropTypes from 'prop-types';

import SrBadge, { SR_BADGE_THEME_PURPLE, SR_BADGE_THEME_GREY } from 'client/components/SrBadge/SrBadge';

const ZapIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);

const HistoryIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <path d="M3 3v5h5" />
    <path d="M12 7v5l4 2" />
  </svg>
);

const SrActivationFlowBadge = ({ isOnSwitchFlow }) => {
  return (
    <SrBadge
      theme={isOnSwitchFlow ? SR_BADGE_THEME_PURPLE : SR_BADGE_THEME_GREY}
      icon={isOnSwitchFlow ? <ZapIcon /> : <HistoryIcon />}
    >
      {isOnSwitchFlow ? 'On Switch Flow' : 'Legacy Flow'}
    </SrBadge>
  );
};

SrActivationFlowBadge.propTypes = {
  isOnSwitchFlow: PropTypes.bool.isRequired,
};

SrActivationFlowBadge.displayName = 'SrActivationFlowBadge';

export default SrActivationFlowBadge;
